import { useMutation, useQueryClient } from '@tanstack/react-query'

import { Observation } from '../../types'
import { Annotation, AnnotationType } from '../../types/annotation'
import { get, post } from '../../utils/api'

const GROUND_TRUTH_SOURCE = 'GT'

type NewAnnotationDTO = {
  observationId: number
  annotationType: AnnotationType
  data: unknown
}

export const useCreateAnnotation = () => {
  const queryClient = useQueryClient()

  return useMutation(
    ({ observationId, annotationType, data }: NewAnnotationDTO) =>
      post<Annotation>('/observation_annotations/', {
        observationId,
        annotationType,
        annotationSource: GROUND_TRUTH_SOURCE,
        data,
      }).then((response) =>
        get<Observation>(`/observations/${response.observation.id}/`)
      ),
    {
      retry: false,
      onSuccess: (_observation) => {
        // TODO: optimize this
        queryClient.invalidateQueries(['observations'])
        queryClient.invalidateQueries(['observation_annotations'])
      },
    }
  )
}
